import React, { useEffect, useState, useMemo } from "react";
import { observer } from "mobx-react";
import styles from "../styles/emissionYearSelector.module.css";
import emissionViewStore from "../../Store/marco/emissionViewStore";
import commonStore from "../../Store/marco/commonStore";
import { emissionActivityModalAPI } from "../API/emissionActivityAPI";
import { useTranslation } from "react-i18next";
import loadingSvg from "../../Assets/images/tube-spinner.svg";

export const EmissionYearSelector = observer(() => {
  const store = emissionViewStore;
  const cmStore = commonStore;
  const API = emissionActivityModalAPI;
  const { t } = useTranslation("ActivityMain");

  const [yearOptions, setYearOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  //////// API 抓可用年分（僅用來比對）
  const getYearOptions = async () => {
    try {
      setIsLoading(true);
      const res = await API.getReportYearDropdownAPI(cmStore.userId);
      setYearOptions(res);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getYearOptions();
  }, []);

  //////// 產生今天往前 10 年
  const yearList = useMemo(() => {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: 10 }, (_, i) => currentYear - i);
  }, []);

  //////// 若使用者沒有選過年份 → 自動選第一個「可用的」
  useEffect(() => {
    if (store.selectedYear) return;

    const firstAvailableOption = yearOptions?.find((opt) =>
      yearList.includes(opt.value)
    );

    if (firstAvailableOption) {
      store._handleSetSelectedYear(firstAvailableOption.value);
      store._handleSetStandard(firstAvailableOption.standard);
    }
  }, [yearOptions, yearList]);

  const setYear = (year, isAvailable, standardId) => {
    if (!isAvailable) return; // 不可用不能點
    store._handleSetSelectedYear(year);
    store._handleSetStandard(standardId);
    store._handleSetSelectedView("Entity");
  };

  //////// 取得該年度的報告期間給dataEntry用
  useEffect(() => {
    store.fetchReportingPeriod(cmStore.rootId, cmStore.userId);
  }, [store.selectedYear]);

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <h4>{t("Select Year")}</h4>
      </div>

      <div className={styles.yearsWrap}>
        {isLoading ? (
          <div className={styles.loading}>
            <img
              className={styles.loadingImg}
              src={loadingSvg}
              alt="loadingSvg"
            />
          </div>
        ) : (
          yearList.map((year) => {
            const option = yearOptions?.find((opt) => opt.value === year);
            const isAvailable = Boolean(option);
            const isSelected = store.selectedYear === year;

            return (
              <div
                key={year}
                className={`${styles.year} ${
                  isAvailable ? styles.available : styles.disabled
                } ${isSelected && isAvailable ? styles.blue : ""}`}
                onClick={() => setYear(year, isAvailable, option?.standard)}
              >
                {year}
              </div>
            );
          })
        )}
      </div>

      <div className={styles.description}>
        <p>
          {t(
            "Start with boundary setting for the selected year, followed by emission activity data entry."
          )}
        </p>
      </div>
    </div>
  );
});
